import React from 'react';
import classNames from 'classnames';
import styles from './IconList.module.scss';
import { IconListItem, IconListItemProps } from 'ui/components/2-molecules/IconListItem/';

export interface IconListProps {
	className?: string;
	itemList?: string[];
}

export const IconList: React.FC<IconListProps> = ({ className, itemList }) => {
	return (
		<ul className={classNames(styles.IconList, className)}>
			{itemList?.map((item, index) => (
				<IconListItem key={index} iconSize="lg" text={item} />
			))}
		</ul>
	);
};
